// import sWORKOUT_EXERCISES_NON_SAVABLE_ASSOCIATIONS from 'constants/workout-exercise/non-savable-associations'
const REDUX_NON_SAVABLE_ASSOCIATION = {
  // [ WORKOUT_EXERCISE_CLASS_NAME ]: WORKOUT_EXERCISES_NON_SAVABLE_ASSOCIATIONS
}
export default REDUX_NON_SAVABLE_ASSOCIATION
